import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CmsLayoutInstanceContainerModel } from '../../../../../../models';
import { ApiVisa, BaseApiTemplateService, Core2Config, PagingResponseModel } from '../../shared';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({providedIn: 'root'})
export class CmsLayoutInstanceService extends BaseApiPublicLoginTemplateService<CmsLayoutInstanceContainerModel, CmsLayoutInstanceContainerModel, CmsLayoutInstanceContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'layout-instances';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'layout-instances';
    this.httpClient = http;
    this.endpoint_path_public_url =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'layout-instances/' + BaseApiTemplateService.PUBLIC_EP;
  }

  getPublicInstanceByCode(instanceCode: string , apiVisa: ApiVisa): Observable<PagingResponseModel<CmsLayoutInstanceContainerModel>>  {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/public/' + instanceCode + '?tenantCode=' + apiVisa.tenantCode;
    }
    return this.httpClient.get<PagingResponseModel<CmsLayoutInstanceContainerModel>>(this.apiUrl);
  }

  getPublicInstanceByCode2(instanceCode: string , apiVisa: ApiVisa): Observable<PagingResponseModel<CmsLayoutInstanceContainerModel>>  {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/instance-code/public-ep/' + instanceCode;
    }
    return this.httpClient.get<PagingResponseModel<CmsLayoutInstanceContainerModel>>(this.apiUrl);
  }

}

